export const colors = {
    azul: "#1e2b4e",
    branco: "#ffffff",
    cinza: "#1e1e1e",
    preto: "#000000",
    backgroundPage: "#efefef",
};